import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PublicLayout from '../components/PublicLayout';
import { useToast } from '../components/ToastContainer';
import './CommonPages.css';

const Contact = () => {
  const { i18n } = useTranslation();
  const { showSuccess } = useToast();
  const tr = i18n.language?.startsWith('tr');
  const [formData, setFormData] = useState({ name: '', email: '', company: '', topic: 'sales', message: '' });

  const page = tr
    ? {
        title: 'İletişim',
        subtitle: 'Satış, destek veya ortaklık — doğru ekibe ulaşın.',
        infoTitle: 'Kanallar',
        channels: [
          { label: 'Satış', value: 'sales@arcvpn.com', detail: 'Planlar, demo ve kurumsal teklifler' },
          { label: 'Destek', value: 'support@arcvpn.com', detail: 'Teknik yardım ve olay takibi' },
          { label: 'Ofis', value: 'İstanbul', detail: 'Maslak, Sarıyer — randevu ile' },
          { label: 'Saatler', value: '09:00 – 18:00', detail: 'Pazartesi – Cuma (TR saati)' },
        ],
        formTitle: 'Mesaj gönderin',
        fields: { name: 'Ad Soyad', email: 'E-posta', company: 'Şirket', topic: 'Konu', message: 'Mesaj', submit: 'Gönder' },
        topics: [
          { value: 'sales', label: 'Satış' },
          { value: 'support', label: 'Destek' },
          { value: 'partnership', label: 'Ortaklık' },
          { value: 'other', label: 'Diğer' },
        ],
        success: 'Mesajınız alındı. En kısa sürede dönüş yapacağız.',
      }
    : {
        title: 'Contact',
        subtitle: 'Sales, support, or partnerships — reach the right team.',
        infoTitle: 'Channels',
        channels: [
          { label: 'Sales', value: 'sales@arcvpn.com', detail: 'Plans, demos, and enterprise quotes' },
          { label: 'Support', value: 'support@arcvpn.com', detail: 'Technical help and incident follow-up' },
          { label: 'Office', value: 'Istanbul', detail: 'Maslak, Sariyer — by appointment' },
          { label: 'Hours', value: '09:00 – 18:00', detail: 'Monday – Friday (TR time)' },
        ],
        formTitle: 'Send a message',
        fields: { name: 'Full name', email: 'Email', company: 'Company', topic: 'Topic', message: 'Message', submit: 'Send' },
        topics: [
          { value: 'sales', label: 'Sales' },
          { value: 'support', label: 'Support' },
          { value: 'partnership', label: 'Partnership' },
          { value: 'other', label: 'Other' },
        ],
        success: 'Message received. We will get back to you shortly.',
      };

  const handleSubmit = (e) => {
    e.preventDefault();
    showSuccess(page.success);
    setFormData({ name: '', email: '', company: '', topic: 'sales', message: '' });
  };

  return (
    <PublicLayout title={page.title} subtitle={page.subtitle}>
      <div className="common-page contact-shell">
        <aside className="arc-panel contact-aside">
          <h2>{page.infoTitle}</h2>
          <div className="contact-channels">
            {page.channels.map((channel) => (
              <div key={channel.label}>
                <h4>{channel.label}</h4>
                <strong>{channel.value}</strong>
                <p>{channel.detail}</p>
              </div>
            ))}
          </div>
        </aside>

        <form className="arc-panel contact-form-modern" onSubmit={handleSubmit}>
          <h2>{page.formTitle}</h2>
          <label>
            <span>{page.fields.name}</span>
            <input required value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
          </label>
          <label>
            <span>{page.fields.email}</span>
            <input type="email" required value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
          </label>
          <label>
            <span>{page.fields.company}</span>
            <input value={formData.company} onChange={(e) => setFormData({ ...formData, company: e.target.value })} />
          </label>
          <label>
            <span>{page.fields.topic}</span>
            <select value={formData.topic} onChange={(e) => setFormData({ ...formData, topic: e.target.value })}>
              {page.topics.map((topic) => (
                <option key={topic.value} value={topic.value}>{topic.label}</option>
              ))}
            </select>
          </label>
          <label>
            <span>{page.fields.message}</span>
            <textarea rows="5" required value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })} />
          </label>
          <button type="submit" className="arc-btn arc-btn-solid arc-btn-lg">{page.fields.submit}</button>
        </form>
      </div>
    </PublicLayout>
  );
};

export default Contact;
